import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import { memo } from 'react'
import { Line } from 'react-chartjs-2'

import { CHART_INK } from '@shared/config'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
)

//
//

const FCLineChart = ({ data, yAxisUnit, ref }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    spanGaps: true,
    plugins: {
      legend: {
        // a single series needs no legend, the title names it
        display: (data?.datasets?.length || 0) > 1,
        labels: {
          color: CHART_INK.muted,
          usePointStyle: true,
          boxWidth: 8,
          boxHeight: 8,
          font: { size: 12 },
        },
      },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            `${ctx.dataset.label}: ${ctx.formattedValue}${yAxisUnit ? ` ${yAxisUnit}` : ''}`,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: CHART_INK.muted,
          font: { size: 11 },
          maxRotation: 45,
          autoSkip: true,
        },
        grid: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: CHART_INK.muted,
          font: { size: 11 },
          precision: 0,
        },
        grid: { color: CHART_INK.grid },
      },
    },
    elements: {
      line: { borderWidth: 2, tension: 0.3 },
      point: { radius: 3, hoverRadius: 5, hitRadius: 12 },
    },
  }

  return <Line ref={ref} data={data} options={options} />
}

export const LineChart = memo(FCLineChart)
